// extracted by mini-css-extract-plugin
export default {"trigger":"trigger-n3nXg","narrow":"narrow-tC9UW","popover":"popover-EkdOL"};